@for (product of productProtectionItems; track product) {
  <protection-plans-item [product]="product"></protection-plans-item>
}
